import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { API_URL } from '../utils/Function'
import '../Css/Footer.css'

export default function Footer() {
  const footerRef = useRef(null);
  const navigate = useNavigate();
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch services from API
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await fetch(`${API_URL}/service.php/get?limit=6`);
        const data = await response.json();
        
        if (data.success) {
          setServices(data.services || []);
        }
      } catch (error) {
        console.error('Error fetching services:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  useEffect(() => {
    const footerElement = footerRef.current; // ✅ snapshot ref for cleanup

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('footer-visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    if (footerElement) {
      observer.observe(footerElement);
    }

    return () => {
      if (footerElement) {
        observer.unobserve(footerElement);
      }
    };
  }, []);

  // Function to handle scroll to top and section display
  const handleScrollToSection = (sectionId) => {
    // If we're not on the main page, navigate to main page first
    if (window.location.pathname !== '/') {
      navigate('/');
      // Wait a bit for navigation to complete then scroll
      setTimeout(() => {
        scrollToSection(sectionId);
      }, 100);
    } else {
      scrollToSection(sectionId);
    }
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      window.scrollTo({
        top: element.offsetTop,
        behavior: 'smooth'
      });
    }
  };

  // Function to handle navigation to Careers page
  const handleNavigateToCareers = () => {
    navigate('/Careers');
  };

  // Function to handle service navigation
  const handleServiceNavigation = (serviceSlug) => {
    navigate(`/services/${serviceSlug}`);
  };



  return (
    <footer className="footer" ref={footerRef}>
      <div className="footer-container">
        <div className="footer-content">
          {/* Company Info Section */}
          <div className="footer-section company-info">
            <div className="company-logo">
              <img src="/images/Logo-Safpro__1.png" alt="SafPro Technology Solutions Logo" />
            </div>
            <p className="company-descriptions">
              We are a leading IT company specializing in innovative technology solutions that drive business growth and digital transformation.
            </p>
            <a href="/about-safproview" className="read-more">
              Read More <span className="arrow">→</span>
            </a>
          </div>

          {/* Quick Links Section */}
          <div className="footer-section quick-links">
            <h3 className="footer-title">Quick Links</h3>
            <ul className="footer-links">
              <li>
                <a 
                  href="#home" 
                  onClick={(e) => {
                    e.preventDefault();
                    handleScrollToSection('home');
                  }}
                  style={{cursor:'pointer', color:'#b8b4d4'}}
                  
                >
                  <span className="icon"><img src="/images/Home.png" alt="Home icon" /></span>
                  Home
                </a>
              </li>
              <li>
                <a 
                  href="#about-us" 
                  onClick={(e) => {
                    e.preventDefault();
                    handleScrollToSection('about-us');
                  }}
                  style={{color:'#b8b4d4'}}
                >
                  <span className="icon"><img src="/images/info.png" alt="About icon" /></span>
                  About
                </a>
              </li>
              <li>
                <a 
                  href="#services" 
                  onClick={(e) => {
                    e.preventDefault();
                    handleScrollToSection('services');
                  }}
                  style={{color:'#b8b4d4'}}
                >
                  <span className="icon"><img src="/images/sitting.png" alt="Services icon" /></span>
                  Services
                </a>
              </li>
              <li>
                <a 
                  onClick={()=>navigate('/productsView')}
                 style={{cursor:'pointer', color:'#b8b4d4'}}
                >
                  <span className="icon"><img src="/images/share.png" alt="Products icon" /></span>
                  Products
                </a>
              </li>
              <li>
                <a 
                  style={{cursor:'pointer',color:'#b8b4d4'}}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigateToCareers();
                    navigate('/Careers');
                  }}
                >
                  <span className="icon"><img src="/images/careers.png" alt="Careers icon" /></span>
                  Careers
                </a>
              </li>
              <li>
                <a 
                style={{cursor:'pointer', color:'#b8b4d4'}}
  onClick={()=>navigate('/Contactus')}                
                >
                  <span className="icon"><img src="/images/mail-1.png" alt="Contact icon" /></span>
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Our Services Section - Dynamic */}
          <div className="footer-section services">
            <h3 className="footer-title">Our Services</h3>
            {loading ? (
              <div className="loading-services">
                <p>Loading services...</p>
              </div>
            ) : services.length > 0 ? (
              <ul className="service-list">
                {services.map((service) => (
                  <li key={service.id}>
                    
                    <div className="service-contents">
                      <h4 
                        onClick={() => handleServiceNavigation(service.slug)}
                        style={{ cursor: 'pointer', textDecoration: 'none'}}
                      >
                        {service.title}
                      </h4>
                    </div>
                  </li>
                ))}
              </ul>
            ) : (
              <div className="no-services">
                <p>No services available</p>
              </div>
            )}
          </div>

          {/* Contact Info Section */}
          <div className="footer-section contact-info">
            <h3 className="footer-title">Contact Info</h3>
            <ul className="contact-list">
              <li>
                <span className="contact-icon"><img src="/images/location-1.png" alt="Location icon" /></span>
                <div className="contacts-details">
                  <p>#303 VSB EDIFICE</p>
                  <p>Perrambut, Vellore, TN</p>
                </div>
              </li>
              <li>
                {/* <span className="contact-icon"><img src="/images/phone-1.png" alt="Phone icon" /></span>
                <div className="contacts-details">
                  <p>Office: <a href="tel:+919789621043">+91 9789621043</a></p>
                </div> */}
              </li>
              <li>
                <span className="contact-icon"><img src="/images/time-date.png" alt="Working hours icon" /></span>
                <p>Mon–Fri: 10:30 AM–7:30 PM</p>
              </li>
              <li>
                <span className="contact-icon"><img src="/images/mail-2.png" alt="Mail icon" /></span>
                <a href="mailto:info@safprotech.com">info@safprotech.com</a>
              </li>
              <li>
                <span className="contact-icon"><img src="/images/globe.png" alt="Website icon" /></span>
                <a href="https://www.safprotech.com" target="_blank" rel="noopener noreferrer">
                  www.safprotech.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Footer Bottom */}
<div className="footer-bottom">
 <p className="copyright">
  © {new Date().getFullYear()} SAFPRO Technology Solution. All Rights Reserved.
</p>

  <div className="social-links">
    <a 
      href="https://www.linkedin.com/company/safpro-technology-solutions/" 
      className="social-icon" 
      aria-label="LinkedIn"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img src="/images/linkedin.png" alt="LinkedIn" />
    </a>
    <a 
      href="https://www.facebook.com/p/Safpro-Technology-Solutions-100088473216905/" 
      className="social-icon" 
      aria-label="Facebook"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img src="/images/facebook.png" alt="Facebook" />
    </a>
    <a 
      href="https://www.instagram.com/safprotechnologysolutions/" 
      className="social-icon" 
      aria-label="Instagram"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img src="/images/insta.png" alt="Instagram" />
    </a>
  </div>
</div>
      </div>
    </footer>
  )
}